import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose} from 'recompose'
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap'
import {fieldsToDataToSend} from '../../common/functions/convert'
import WithAjax from '../../common/helpers/WithAjax'
import WithNotify from '../../common/helpers/WithNotify'
import {validateField} from '../../../actions/helpers/validation'
import {
  fetchVoiceTestActivateDataSuccess,
  validateVoiceTestActivateField,
  validateVoiceTestActivateWorkAmountUnitField,
  submitVoiceTestActivateFields,
  clearVoiceTestActivateFields,
  clearVoiceTest} from '../../../actions/pages/voice-test-page'
import EditForm from '../../../pages/EditForm'
import InputField from '../../common/form/InputField'
import Textarea from '../../../pages/Textarea'
import Select from '../../common/form/Select'
import DateTimeField from '../../common/form/DateTimeField'
import Alert from '../../../ui-elements/alerts/Alert'
import '../../../css/ui-elements/modals.css'

class ActivateOrEditVoiceTestPopup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: false,
      className: 'modal-primary',
      size: 'default',
      errorMsg: null
    }

    this.toggle = this.toggle.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.openPopup = this.openPopup.bind(this)
  }

  openPopup() {
    let id = parseInt(this.props.voiceTestId, 10);

    if (!Number.isInteger(id)){
      return;
    }

    this.toggle();

    let url = 'voicetests/' + id + '/edit';

    this.props.clearVoiceTestActivateFields();
    this.setState({
      errorMsg: null
    })

    this.props.ajax.get(url, true, (data) => {
      this.props.fetchVoiceTestActivateDataSuccess(data, this.descriptionRequired());
    });
  }

  descriptionRequired() {
    return this.props.profileType == "Singer" || this.props.profileType == "VoiceActor";
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    })
  }

  submitForm(event) {
    event.preventDefault();

    let validatedFields = this.props.fields.map(field => validateField(field))

    let isValid =
        validatedFields.filter(field => field.errors.length > 0).length > 0
          ? false
          : true

    this.props.submitVoiceTestActivateFields(validatedFields);

    if (!isValid){
      return;
    }

    let dataToSend = fieldsToDataToSend(this.props.fields);

    let voiceTestStatus = this.props.voiceTestOverview.Status;
    let url = 'voicetests/' + this.props.voiceTestId ;

    if (voiceTestStatus === 'Draft') {
      url = url + '/activate';
    }

    this.props.ajax.put(
      url,
      JSON.stringify(dataToSend),
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      },
      (response) => {
        if (response.Status === 'OK') {
          this.toggle();
          this.props.clearVoiceTest();
          this.props.notify(`The voice test was ${voiceTestStatus === 'Draft' ? 'activated' : 'updated'}.`);
        }
        else{
          this.setState({
            errorMsg: `Can not ${voiceTestStatus === 'Draft' ? 'activate' : 'update'} voice test (id: ${this.props.voiceTestId})`
          })
        }
      })
  }

  render() {
    let voiceTestStatus = this.props.voiceTestOverview.Status;
    let productionStatus = this.props.voiceTestOverview.ProductionStatus;

    if (productionStatus !== 'Active' || (voiceTestStatus !== 'Draft' && voiceTestStatus !== 'Active')) {
      return (null)
    }

    let fields = this.props.fields;

     //VisibilityType
    let visibilityType = fields[5];

     visibilityType.filteredOptions=[
       {value:"Everyone", label: "Everyone"},
       {value:"CandidatesOnly", label: "Candidates only"}
     ]

     var selectedVisibilityType = fields[5].filteredOptions.find((option) => {
       return option.value === fields[5].value;
     });
     //end VisibilityType
    return (
      <div style={{display: 'inline-block'}}>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          wrapClassName={this.state.className}
          size={this.state.size}>
          <ModalHeader toggle={this.toggle}>{voiceTestStatus === 'Draft' ? 'Activate voice test': 'Edit voice test'}</ModalHeader>
          <ModalBody>
            <div data-background={this.props.config.background}>
              {this.state.errorMsg &&
                <Alert className="alert alert-danger alert-outline">
                  {this.state.errorMsg}
                </Alert>
              }

              <EditForm
                title=""
                description="">
                {fields[4] && this.descriptionRequired() && <InputField field={fields[4]} validate={this.props.validateVoiceTestActivateField} />}
                {fields[0] && <DateTimeField field={fields[0]} validate={this.props.validateVoiceTestActivateField} />}
                {fields[5] && <Select field={fields[5]} validate={this.props.validateVoiceTestActivateField} />}
                {fields[1] && <InputField field={fields[1]} validate={this.props.validateVoiceTestActivateField} />}
                {fields[2] && <Select field={fields[2]} validate={this.props.validateVoiceTestActivateWorkAmountUnitField} />}
                {fields[3] && <Textarea field={fields[3]} validate={this.props.validateVoiceTestActivateField} rows="3" />}
              </EditForm>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="btn btn-primary btn-rounded" type="submit" onClick={this.submitForm}>
            {voiceTestStatus === 'Draft' ? 'Activate': 'Save'}
            </button>
            <button className="btn btn-default btn-rounded" onClick={this.toggle}>
              Close
            </button>
          </ModalFooter>
        </Modal>

        <button
          className="btn btn-primary btn-rounded mx-2"
          type="button"
          onClick={this.openPopup}>
          {voiceTestStatus === 'Draft' ? 'Activate': 'Edit'}
        </button>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  voiceTestOverview: state.voiceTestPage.overview,
  fields: state.voiceTestActivate.fields,
  config: state.config
})
const mapDispatchToProps = dispatch => ({
  fetchVoiceTestActivateDataSuccess: (activateData, descriptionRequired) => dispatch(fetchVoiceTestActivateDataSuccess(activateData, descriptionRequired)),
  submitVoiceTestActivateFields: fields => dispatch(submitVoiceTestActivateFields(fields)),
  validateVoiceTestActivateField: (value, field) => dispatch(validateVoiceTestActivateField(value, field)),
  validateVoiceTestActivateWorkAmountUnitField: (value, field) => {
    dispatch(validateVoiceTestActivateWorkAmountUnitField(value, field))
  },
  clearVoiceTestActivateFields: () => dispatch(clearVoiceTestActivateFields()),
  clearVoiceTest: () => dispatch(clearVoiceTest())
})
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  WithNotify,
  WithAjax)(ActivateOrEditVoiceTestPopup)
